import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MyChecklistsPage from './pages/MyChecklistsPage';
import StartRunPage from './pages/StartRunPage';
import RunQuestionPage from './pages/RunQuestionPage';
import RunCompletePage from './pages/RunCompletePage';
import PrintPage from './pages/PrintPage';
import TemplatesListPage from './pages/TemplatesListPage';
import TemplateEditorPage from './pages/TemplateEditorPage';
import AllRunsPage from './pages/AllRunsPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/ProfilePage';
import AuditLogPage from './pages/AuditLogPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/checklists/:runId/print" element={<ProtectedRoute><PrintPage /></ProtectedRoute>} />
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/checklists" element={<MyChecklistsPage />} />
              <Route path="/checklists/new" element={<StartRunPage />} />
              <Route path="/checklists/:runId/question" element={<RunQuestionPage />} />
              <Route path="/checklists/:runId/complete" element={<RunCompletePage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/admin/templates" element={<AdminRoute><TemplatesListPage /></AdminRoute>} />
              <Route path="/admin/templates/new" element={<AdminRoute><TemplateEditorPage /></AdminRoute>} />
              <Route path="/admin/templates/:templateId/edit" element={<AdminRoute><TemplateEditorPage /></AdminRoute>} />
              <Route path="/admin/runs" element={<AdminRoute><AllRunsPage /></AdminRoute>} />
              <Route path="/admin/users" element={<AdminRoute><UsersPage /></AdminRoute>} />
              <Route path="/admin/settings" element={<AdminRoute><SettingsPage /></AdminRoute>} />
              <Route path="/admin/audit-log" element={<AdminRoute><AuditLogPage /></AdminRoute>} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
